import {
    ZOOM_IN,
    ZOOM_OUT,
    SET_ZOOM,
    SET_CENTER,
    TOGGLE_HEADQUARTERS
} from './actions';

const initialState = {
    zoom: 5,
    headquarters: false,
    center: {
        lat: 0,
        lng: 0
    },
};

export default function mapSettings(state = initialState, action) {
    switch (action.type) {
    case ZOOM_IN:
        return { ...state, zoom: state.zoom + 1 };

    case ZOOM_OUT:
        if (state.zoom === 0) {
            return state;
        }
        return { ...state, zoom: state.zoom - 1 };

    case SET_ZOOM:
        return { ...state, zoom: action.zoom };

    case SET_CENTER: {
        const { latLng } = action;

        if (!latLng) {
            return state;
        }

        return {
            ...state,
            center: {
                lat: parseFloat(latLng.lat),
                lng: parseFloat(latLng.lng),
            }
        };
    }

    case TOGGLE_HEADQUARTERS:
        return { ...state, headquarters: !state.headquarters };

    default:
        return state;
    }
}
